import { useState } from 'react';

/**
 * Πότε εμφανίζεται το μήνυμα ενός πεδίου.
 *
 * Ο κανόνας δεν είναι «πάντα»: ένα μήνυμα «τουλάχιστον 8 χαρακτήρες» στο κενό
 * πεδίο, πριν γράψει ο χρήστης τον πρώτο χαρακτήρα, είναι κατηγορία και όχι
 * βοήθεια. Εμφανίζεται όταν ισχύει ένα από τα δύο:
 *
 *   • ο χρήστης **έφυγε** από το πεδίο (blur), οπότε το θεωρεί συμπληρωμένο· ή
 *   • **υποβλήθηκε** η φόρμα, οπότε πρέπει να φανούν όλα τα εκκρεμή.
 *
 * Μετά το πρώτο blur το μήνυμα ενημερώνεται **σε κάθε πάτημα πλήκτρου**, ώστε ο
 * χρήστης να βλέπει τη διόρθωσή του να ισχύει αμέσως.
 */
export function useValidation() {
    const [touched, setTouched] = useState({});
    const [submitted, setSubmitted] = useState(false);

    return {
        submitted,

        /** Στο `onBlur` του πεδίου. */
        touch: (name) => () => setTouched((current) => ({ ...current, [name]: true })),

        /** Το μήνυμα, αν πρέπει να φαίνεται. Αλλιώς `undefined`. */
        show: (name, message) => ((touched[name] || submitted) ? message : undefined),

        /** Στην υποβολή: εμφανίζει τα εκκρεμή και δηλώνει αν η φόρμα είναι έγκυρη. */
        markSubmitted: () => setSubmitted(true),

        /** Καθαρισμός, όταν η φόρμα ανοίγει από την αρχή. */
        reset: () => {
            setTouched({});
            setSubmitted(false);
        }
    };
}

export default useValidation;
